import { FC } from 'react';

import Image from 'next/image';

import styled, { keyframes } from 'styled-components';

import { VMCORE_BRAND } from '../../constants/vmcore-brand';

const iconRotation = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const AnimatedLogo = styled.span`
  position: relative;
  display: inline-flex;
  max-width: 100%;

  /* Mantém o lettering original e substitui somente o símbolo do SVG. */
  > img:first-child {
    clip-path: inset(0 0 0 15%);
  }

  > img:last-child {
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: center;
    animation: ${iconRotation} 24s linear infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    > img:last-child {
      animation: none;
    }
  }
`;

interface IVmcoreLogoProps {
  variant?: 'horizontal' | 'icon';
  /** Altura em px; a proporção original do SVG é preservada. */
  height?: number;
  /** `light` para fundos escuros; `dark` para fundos claros. */
  tone?: 'light' | 'dark';
  /** Gira apenas o símbolo do logo horizontal. */
  animateIcon?: boolean;
}

export const VmcoreLogo: FC<IVmcoreLogoProps> = ({
  variant = 'horizontal',
  height = 36,
  tone = 'light',
  animateIcon = false,
}) => {
  const isIcon = variant === 'icon';
  const src = isIcon
    ? tone === 'light'
      ? VMCORE_BRAND.iconLight
      : VMCORE_BRAND.icon
    : tone === 'light'
    ? VMCORE_BRAND.logoLight
    : VMCORE_BRAND.logo;
  const width = height * (isIcon ? 414.45 / 411.32 : 719.89 / 102.5);

  const logo = (
    <Image
      src={src}
      alt="VMCORE"
      width={width}
      height={height}
      unoptimized
      style={{ display: 'block', maxWidth: '100%', objectFit: 'contain' }}
    />
  );

  if (!animateIcon || isIcon) return logo;

  return (
    <AnimatedLogo style={{ width, height }}>
      {logo}
      <Image
        src={VMCORE_BRAND.icon}
        alt=""
        aria-hidden="true"
        width={height * (103.27 / 102.5)}
        height={height}
        unoptimized
      />
    </AnimatedLogo>
  );
};
